<!-- 联系我们 -->
<template>
    <div class="contactUs">
        <div class="titleBOx">
               <h2 class="title">
                {{help.titel78}}
            </h2>
        </div>
        <div class="content"> 
            <h3 class="tip1">{{help.titel79}}</h3>
            <p class="tip2">{{help.titel80}}</p>
            <p class="tip2"><span class="tip3">{{help.titel81}}</span>{{help.titel82}}</p>
            <h3 class="tip1">{{help.titel83}}</h3>
            <p class="tip2"><a @click="openCustomer()" href="javascript:;">{{help.titel84}}</a></p>
            <!-- <p class="tip2">{{help.titel85}}</p> -->
            <p v-if="platReg === 'amjs'" class="tip2">{{help.titel86}}</p>
            <p v-if="platReg === 'amjs'" class="tip2">{{help.titel87}}</p>
            <p v-if="platReg === 'bmyl'" class="tip2">2.建议及投诉邮箱：bmyl011926@gmail.com</p>
            <p v-if="platReg === 'bmyl'" class="tip2">3.代理咨询QQ：717544932</p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            platReg: ''
        }
    },
    computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
        openCustomer() {
            window.open(this.$common.getCustomerService(), "_blank");
        }
    },
    mounted(){
        this.platReg = window.projectImgUrl;
    }
}
</script>
<style scoped lang='scss'>
    .contactUs{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            .tip1{
                padding: 0px 0px 20px;
                line-height: 30px;
                font-size: 18px;
                font-weight: 500;
            }
            .tip2{
                line-height: 32px;
                font-size: 14px;
                color: #666;
                text-indent: 2em;
                padding-bottom: 20px;
                .tip3{
                    color: #ec2828;
                }
            }
        }
    }
</style>